import { Dispatch, MouseEvent, SetStateAction, useEffect, useState } from 'react';

import { Button, InfoMessage, Input, Label, Modal, ModalInner, SelectBox, Text } from 'components';
import { ContactProfileDetailData } from './types';
import { manageModalList } from './utils';
import { InformationCircleOutlineIcon, XOutlineIcon } from 'assets/svgs';
import { Message } from 'types/message';
import axios from 'common/AxiosAuth';
import DetailDeleteModal from './DetailDeleteModal';

interface ListElementProps {
  title: string;
  value: string;
}

interface ModalProps {
  data: ContactProfileDetailData | null;
  setData: Dispatch<SetStateAction<ContactProfileDetailData | null>>;
  onDelete?: (e: MouseEvent<HTMLButtonElement>) => void;
  onEdit?: (e: MouseEvent<HTMLButtonElement>) => void;
  onContactProfileUpdated: () => Promise<void>;
}

const ContactProfileModalListElement = ({ title, value }: ListElementProps) => {
  return (
    <li className="border-primary rounded-lg border px-3 py-2">
      <Text weight="regular" size="body2" color="tertiary">
        {title}
      </Text>
      <Text weight="regular" size="body2" color="primary">
        {value}
      </Text>
    </li>
  );
};

const ContactProfileModal = ({ data, setData, onContactProfileUpdated }: ModalProps) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalOpened, setIsDeleteModalOpened] = useState(false);
  const [messageArray, setMessageArray] = useState<Message[]>([]);
  const [messageArrayCount, setMessageArrayCount] = useState(0);
  const [city, setCity] = useState<string>('');
  const [groundStaionName, setGroundStaionName] = useState<string>('');
  const [minContactDuration, setMinContactDuration] = useState<number>(0);
  const [minElevationDegrees, setMinElevationDegrees] = useState<number>(0);
  const [name, setName] = useState<string>('');
  const [registeredAt, setRegisteredAt] = useState<string>('');

  async function onSave () {
    const params = {
      id:data?.contactProfileId,
      city: city,
      groundStaionName:groundStaionName,
      minContactDuration:minContactDuration,
      minElevationDegrees:minElevationDegrees,
      name:name,
    };
    const contactProfileRes = await axios.patch(`/api/contactprofile/${data?.contactProfileId}`, params);
    console.log('contactProfileRes',contactProfileRes);
    setMessageArray((prev) => [
      ...prev,
      {
        index: messageArrayCount,
        icon: <InformationCircleOutlineIcon />,
        text: `Registration has been completed`
      }
    ]);
    setTimeout(() => onClickDeleteButton(messageArrayCount), 2000);
    setMessageArrayCount((prev) => prev + 1);
    onContactProfileUpdated();
    setData(null);
    setIsEdit(false);
  }

  useEffect(() => {
    if(data && isEdit === true) {
      setName(data['name']);
      setCity(data['city']);
      setMinContactDuration(data['minContactDuration']);
      setMinElevationDegrees(data['minElevationDegrees']);
      setRegisteredAt(data['registeredAt']);
    }
  },[data, isEdit]);

  const onEdit = () => {
    setIsEdit(true);
  };

  const handleGoBack = () => {
    setIsEdit(false);
  };

  const openDeleteModal = () => {
    setIsDeleteModalOpened(true);
  };

  function onClickDeleteButton(index: number) {
    setMessageArray((prev) => prev.filter((message: any) => message.index !== index));
  }

  const closeModal= () => {
    setIsEdit(false);
    setData(null);
  };

  useEffect(()=> {
    if(!data) {
      setIsEdit(false);
    }
  },[data]);


  return (
    <>
      <Modal isOpened={!!data}>
        {/* input */}
        {isEdit && data && (
          <div className="h-fit w-[560px] rounded-2xl bg-white shadow-primary">
            <div className="flex flex-row items-center justify-between p-4">
              <Text size="body1" weight="semibold">{data.name}</Text>
              <button type="button" className="flex h-8 w-8 items-center justify-center" onClick={closeModal}>
                <XOutlineIcon className="h-4 w-4" onClick={handleGoBack} />
              </button>
            </div>
            <ul className="flex max-h-[60vh] flex-col gap-4 overflow-auto px-4 pb-4">
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input
                  label="Name"
                  value={name}
                  setValue={setName}
                />
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <p className="text-text-tertiary font-regular text-body2">Ground Staion</p>
                <p className="text-text-primary font-regular text-body2">{data['groundStationName']}</p>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <p className="text-text-tertiary font-regular text-body2">City</p>
                <p className="text-text-primary font-regular text-body2">{data['city']}</p>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <p className="text-text-tertiary font-regular text-body2">Location</p>
                <p className="text-text-primary font-regular text-body2">{data['location']}</p>
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Minimum Contact Duration" labelTooltip="Minimum Contact Duration" type="number" value={minContactDuration} setValue={setMinContactDuration} placeholder='' />
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <Input label="Minimum elevation in degrees" labelTooltip="Minimum elevation in degrees" type="number" value={minElevationDegrees} setValue={setMinElevationDegrees} placeholder='' />
              </li>
              <li className="border-primary rounded-lg border px-3 py-2">
                <p className="text-text-tertiary font-regular text-body2">Registered At</p>
                <p className="text-text-primary font-regular text-body2">{data['registeredAt']}</p>
              </li>
            </ul>
            <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
              <Button text="Cancel" onClick={closeModal} type="secondary" size="large" />
              <Button text="Save" onClick={onSave} type="primary" size="large" />
            </div>
          </div>
        )}
        {/* View */}
        {!isEdit && data && (
          <ModalInner title={data.name} onClickClose={closeModal}>
            <>
              <ul className="flex max-h-[60vh] flex-col gap-4 overflow-auto px-4 pb-4">
              {manageModalList.map(({ title, key }) => {
                return (
                  <ContactProfileModalListElement
                  
                    key={key}
                    title={title}
                    value={data[key as keyof ContactProfileDetailData]}
                  />
                );
              })}
            </ul>
              <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
                <Button text="Delete" onClick={openDeleteModal} type="secondary" size="large" />
                <Button text="Edit" onClick={onEdit} type="primary" size="large"/>
              </div>
            </>
          </ModalInner>
        )}
      </Modal>
      {isDeleteModalOpened && (
        <DetailDeleteModal
          data={data} 
          setData={setData}
          setIsDeleteModalOpened={setIsDeleteModalOpened}
          onDeleted={onContactProfileUpdated} />
      )}
      <InfoMessage messageArray={messageArray} onClickDelete={onClickDeleteButton} />
    </>
  );
};

export default ContactProfileModal;
